import React, { useState, useEffect } from 'react'
import { Col, Panel, Row, Modal, Button, Icon, Message } from 'rsuite'
import { useForm, Controller } from 'react-hook-form'
import { startLoading, doneLoading } from '../../../utils/loading'
import SaveButton from '../../../components/buttons/saveButton/SaveButton'
import CancelButton from '../../../components/buttons/cancelButton/CancelButton'
import moment from 'moment'
import ConfirmWidget from '../../confirm/ConfirmWidget'
import {
  saveSubProjectIncomeRecord,
  deleteSubProjectIncomeRecord,
  downloadSubProjectIncomeRecordAttacthment,
} from '../../../redux/actions/subProjectIncomeRecord'
import notification from '../../../utils/notification'
import { DEFAULT_ERR_MSG } from '../../../constants/msgText'
import {
  sessionGetItemObj,
  sessionGetItemStr,
  sessionSetItemStr,
} from '../../../utils/sessionHelpers'
import { useHistory } from 'react-router-dom'
import globalMsgUtil from '../../../utils/globalMsgUtil'
import { previewFile } from '../../../utils/fileUtil'
import InputEvaluatesForm from '../InputEvaluatesForm'
import { saveProjectEvaluation } from '../../../redux/actions/projectEvaluation'

export default function CoordinatorEvaluateCoworkerWidget(props) {
  const { showCommandButton, isEdit, onChangeIsEdit } = props
  const { register, handleSubmit, errors, control, getValues, setValue, setError, clearErrors } =
    useForm()
  const [isError, setIsError] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [formSchema, setFormSchema] = useState(props.schema)
  const [request, setRequest] = useState()
  const [isShowConfirm, setIsShowConfirm] = useState(false)
  const [isShowConfirmDelete, setIsShowConfirmDelete] = useState(false)
  const [isEnableEdit, setIsEnableEdit] = useState()
  const [requestBody, setRequestBody] = useState()
  const projectCode = sessionGetItemStr('projectCode')
  const subProjectCode = sessionGetItemStr('subProjectCode')
  const { periodNo } = sessionGetItemObj('subProjectPeriodInfo')
  const subIncomeId = sessionGetItemStr('subIncomeId')
  const isViewOnly = !!sessionGetItemStr('isViewOnly')
  // const projectVersionId = 'E13BFAB8-35BE-4C22-B8E6-6EC127AFF69E'
  // const projectProgressId = '3062F0B2-C127-4746-A2CB-7BB16B522C94'
  const projectId = sessionStorage.getItem('projectId')
  let requestId = sessionStorage.getItem('param')?.substring(1)

  let history = useHistory()
  // console.log('Schema==>', formSchema)

  const handleCallService = async () => {
    startLoading()
    setIsLoading(true)
    setIsError(false)

    try {
      console.log('ok')
      const response = await saveProjectEvaluation(projectId, requestId, requestBody)

      if (response) {
        setFormSchema(formSchema?.forms.evaluations)
        setRequestBody()
        // sessionSetItemStr('subIncomeId', response.model.id)
        notification.open('success', {
          title: globalMsgUtil.SAVE_SUCCESS,
        })
        setIsShowConfirm(false)

        // setTimeout(() => {
        //   location.reload()
        // }, 1000)
      } else {
        setIsError(true)
      }
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        console.log(e?.response?.data)
        setIsError(e.response.data.errorMessage || globalMsgUtil.SET_IS_ERROR)
      } else {
        setIsError(globalMsgUtil.SET_IS_ERROR)
      }
    }

    setIsLoading(false)
    doneLoading()
  }

  const onSubmit = (data) => {
    console.log('on submit ', data)

    let newArr = []
    for (const key in data) {
      console.log(`${key}: ${data[key]}`)
      let newRes = {
        id: key,
        result: Array.isArray(data[key]) ? data[key].toString() : data[key],
        otherResult: '',
      }

      newArr.push(newRes)
    }

    const requestBody = {
      evaluationId: '',
      comment: '',
      results: newArr,
    }

    console.log('requestBody => ', requestBody)
    setRequestBody(requestBody)
    setIsShowConfirm(true)
    // console.log('data', data)
  }

  // console.log('evaluations==>', formSchema?.forms?.evaluations)
  return (
    // <>
    //   <Panel
    //     collapsible
    //     defaultExpanded
    //     header={formSchema.header}
    //     key={index}
    //     style={{ marginBottom: 20 }}
    //   >
    //     {formSchema?.forms?.evaluations.length > 0 &&
    //       formSchema?.forms?.evaluations.map((item, index) => {
    //         return (
    //           <Panel defaultExpanded header={item.name} key={index}>
    //             {item.questions.length > 0 && (
    //               <InputEvaluatesForm
    //                 schema={item.questions}
    //                 register={register}
    //                 Controller={Controller}
    //                 control={control}
    //                 errors={errors}
    //                 getValues={getValues}
    //                 setValue={setValue}
    //                 clearErrors={clearErrors}
    //                 setIsEnableEdit={setIsEnableEdit}
    //               />
    //             )}
    //           </Panel>
    //         )
    //       })}
    //     <hr />
    //     <Row style={{ marginTop: 20 }}>
    //       <Col lg={16} md={16} sm={24} xs={24}></Col>
    //       <Col lg={8} md={8} sm={24} xs={24} style={{ textAlign: 'right' }}>
    //         <SaveButton onClick={handleSubmit(onSubmit)} style={{ marginTop: 0, marginLeft: 0 }}>
    //           {'บันทึกผล'}
    //         </SaveButton>
    //         <CancelButton style={{ marginTop: 0, marginLeft: 20 }}>{'ยกเลิก'}</CancelButton>
    //       </Col>
    //     </Row>
    //   </Panel>

    //   <ConfirmWidget
    //     title={globalMsgUtil.CONFIRM_SAVE_TITLE}
    //     show={isShowConfirm}
    //     detail={globalMsgUtil.CONFIRM_SAVE_DETAIL}
    //     onCancle={() => setIsShowConfirm(false)}
    //     onConfirm={handleCallService}
    //   />
    // </>
    <>
      <Panel
        shaded
        bordered
        collapsible
        defaultExpanded
        header={formSchema.header}
        style={{ marginBottom: '1em' }}
      >
        {formSchema?.forms?.evaluations?.length > 0 &&
          formSchema?.forms?.evaluations?.map((item, index) => {
            return (
              <Panel
                collapsible
                defaultExpanded
                header={item.name}
                key={index}
                style={{ marginBottom: 20 }}
              >
                {item.questions.length > 0 && (
                  <InputEvaluatesForm
                    schema={item.questions}
                    register={register}
                    Controller={Controller}
                    control={control}
                    errors={errors}
                    getValues={getValues}
                    setValue={setValue}
                    clearErrors={clearErrors}
                    setIsEnableEdit={setIsEnableEdit}
                  />
                )}
              </Panel>
            )
          })}
        <hr />
        <Row style={{ marginTop: 20 }}>
          <Col lg={16} md={16} sm={24} xs={24}></Col>
          <Col lg={8} md={8} sm={24} xs={24} style={{ textAlign: 'right' }}>
            <SaveButton onClick={handleSubmit(onSubmit)} style={{ marginTop: 0, marginLeft: 0 }}>
              {'บันทึกผล'}
            </SaveButton>
            <CancelButton style={{ marginTop: 0, marginLeft: 20 }}>{'ยกเลิก'}</CancelButton>
          </Col>
        </Row>
      </Panel>

      <ConfirmWidget
        title={globalMsgUtil.CONFIRM_SAVE_TITLE}
        show={isShowConfirm}
        detail={globalMsgUtil.CONFIRM_SAVE_DETAIL}
        onCancle={() => setIsShowConfirm(false)}
        onConfirm={handleCallService}
      />
    </>
  )
}
